import { useEffect } from 'react';
import { AppShell } from '@/components/layout/AppShell';
import { ensureMqttConnection, syncSubscriptions } from '@/hooks/mqtt/mqttSingleton';
import { AppRoutes } from '@/routes/AppRoutes';

/**
 * 起動時に MQTT 接続を確立し、デフォルト scope の subscribe を開始する。
 * Sim 系ページからの publish も Monitor ページに移動するまでに既に
 * buffer に蓄積される (singleton 設計)。
 */
function useGlobalMqttBootstrap(): void {
  useEffect(() => {
    void (async () => {
      const handle = await ensureMqttConnection();
      if (!handle) return;
      // 起動時は全件 (#) を購読 (Monitor の default scope と一致)
      await syncSubscriptions(['#']);
    })();
  }, []);
}

export function App() {
  useGlobalMqttBootstrap();
  return (
    <AppShell>
      <AppRoutes />
    </AppShell>
  );
}
